/*
 * Referral capture — site-wide. Reads a ?ref=CODE param on any landing and
 * stores it in a first-party cookie (bq_ref) with a localStorage mirror,
 * last-touch with a 30-day sliding window (a fresh ?ref= overwrites and resets).
 *
 * Exposes window.bqGetRef() and auto-fills any hidden [data-lead-ref] inputs so
 * the referral code rides into form submissions (POST /leads + the Shopify inbox).
 *
 * On a FRESH incoming ?ref= it also fires a fire-and-forget beacon to our ops
 * POST /referral-click (endpoint passed on this script tag by referral-capture.liquid)
 * so referral traffic is logged even for visitors who never submit a form. Best-effort,
 * mirrors assets/whatsapp-button.js. See ops/plans/referral-partner-launch.md.
 */
(function () {
  var COOKIE = 'bq_ref';
  var PARAM = 'ref';
  var MAX_AGE_DAYS = 30;

  function readParam() {
    try {
      var v = new URLSearchParams(window.location.search).get(PARAM);
      return v && v.trim() ? v.trim().slice(0, 64) : null; // cap length, defensive
    } catch (e) {
      return null;
    }
  }

  function setRef(value) {
    var maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      COOKIE + '=' + encodeURIComponent(value) +
      '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax' + secure;
    try { window.localStorage.setItem(COOKIE, value); } catch (e) { /* private mode */ }
  }

  function getRef() {
    var match = document.cookie.match(/(?:^|;\s*)bq_ref=([^;]*)/);
    if (match) {
      try { return decodeURIComponent(match[1]); } catch (e) { return match[1]; }
    }
    try { return window.localStorage.getItem(COOKIE) || null; } catch (e) { return null; }
  }

  function clickUrl() {
    // referral-capture.liquid passes POST /referral-click on the script tag
    // (derived from settings.leads_api_url). A deferred asset can't read Liquid
    // globals and document.currentScript is null by the time this IIFE runs, so
    // find the tag by its data attribute. Guard blank/relative → beacon disabled.
    var s = document.querySelector('script[data-referral-click-url]');
    var url = s && s.getAttribute('data-referral-click-url');
    return url && url.indexOf('http') === 0 ? url : '';
  }

  function logClick(code) {
    var url = clickUrl();
    if (!url) return; // logging disabled (no endpoint configured)
    var body = JSON.stringify({
      code: code,
      landing_path: window.location.pathname,
      referer: document.referrer || null
    });
    // sendBeacon is the most reliable during/after navigation (Blob so the
    // content-type is application/json for FastAPI); fall back to a keepalive
    // fetch. Either way best-effort — a failed beacon must never break the page.
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon(url, blob)) return;
      }
    } catch (e) {
      /* fall through to fetch */
    }
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
        mode: 'cors'
      }).catch(function () {});
    } catch (e) {
      /* give up silently */
    }
  }

  // Last-touch: capture the incoming ref before anything reads it, and log the
  // click (only on a fresh ?ref= — not on every internal page view).
  var incoming = readParam();
  if (incoming) {
    setRef(incoming);
    logClick(incoming);
  }

  window.bqGetRef = getRef;

  function fillFields() {
    var ref = getRef();
    if (!ref) return;
    var fields = document.querySelectorAll('[data-lead-ref]');
    for (var i = 0; i < fields.length; i++) fields[i].value = ref;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillFields);
  } else {
    fillFields();
  }
})();
